// Initialize OpenTelemetry first before any other imports
import { setupTelemetry } from "./telemetry";

// Initialize telemetry
setupTelemetry();

import { createRoot } from "react-dom/client";
import App from "./App";

import "@refinedev/antd/dist/reset.css";
import "./index.css";

const container = document.getElementById("root") as HTMLElement;
if (!container) {
    console.error("Root element not found.");
} else {
    const root = createRoot(container);
    root.render(<App />);
}